import React from 'react'

const PoemsAuthor = () => {
  return (
    <div>PoemsAuthor</div>
  )
}

export default PoemsAuthor